import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import SeniorManagement from './pages/SeniorManagement';
import GeneralCare from './pages/GeneralCare';
import Specialized from './pages/Specialized';
import Diagnostic from './pages/Diagnostic';
import News from './pages/News';
import NewsPost from './pages/NewsPost';
import FAQ from './pages/FAQ';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Corporate from './pages/Corporate';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminNews from './pages/AdminNews';
import AdminActivityLogs from './pages/AdminActivityLogs';
import AdminSecurityDashboard from './pages/AdminSecurityDashboard';
import AdminBackups from './pages/AdminBackups';
import AdminChangePassword from './pages/AdminChangePassword';
import AdminDiseases from './pages/AdminDiseases';
import DiseasesIndex from './pages/DiseasesIndex';
import Diseases from './pages/Diseases';
import DiseaseDetail from './pages/DiseaseDetail';
import PatientCenteredCare from './pages/PatientCenteredCare';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import AdminServices from './pages/AdminServices';
import AdminSeniorManagement from './pages/AdminSeniorManagement';
import AdminDonorsPartners from './pages/AdminDonorsPartners';
import AdminDepartments from './pages/AdminDepartments';
import AdminSymptomBrowse from './pages/AdminSymptomBrowse';
import SeniorManagementDetail from './pages/SeniorManagementDetail';
import DonorPartnerDetail from './pages/DonorPartnerDetail';
import DonorsPartners from './pages/DonorsPartners';
import AboutUs from './pages/AboutUs';
import PatientVisitorGuide from './pages/PatientVisitorGuide';
import InsuranceSelfPay from './pages/InsuranceSelfPay';
import BillsPayments from './pages/BillsPayments';
import BeforeArriving from './pages/BeforeArriving';
import DepartmentsCenters from './pages/DepartmentsCenters';
import DepartmentDetail from './pages/DepartmentDetail';
import SymptomsIndex from './pages/SymptomsIndex';
import Symptoms from './pages/Symptoms';
import SymptomRelated from './pages/SymptomRelated';
import SupportTGH from './pages/SupportTGH';
import TestsProceduresIndex from './pages/TestsProceduresIndex';
import TestsProcedures from './pages/TestsProcedures';
import TestProcedureDetail from './pages/TestProcedureDetail';
import AdminTestsProcedures from './pages/AdminTestsProcedures';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import AdminBlogs from './pages/AdminBlogs';
import AdminEvents from './pages/AdminEvents';
import AdminGallery from './pages/AdminGallery';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import AdminProjects from './pages/AdminProjects';
import AdminAnnouncements from './pages/AdminAnnouncements';

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        {/* Public routes with Layout */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about-us" element={<Layout><AboutUs /></Layout>} />
        <Route path="/about-us/:tab" element={<Layout><AboutUs /></Layout>} />
        <Route path="/senior-management" element={<Layout><SeniorManagement /></Layout>} />
        <Route path="/donors-partners" element={<Layout><DonorsPartners /></Layout>} />
        <Route path="/general-care" element={<Layout><GeneralCare /></Layout>} />
        <Route path="/specialized" element={<Layout><Specialized /></Layout>} />
        <Route path="/diagnostic" element={<Layout><Diagnostic /></Layout>} />
        <Route path="/news" element={<Layout><News /></Layout>} />
        <Route path="/news/:id" element={<Layout><NewsPost /></Layout>} />
        <Route path="/faq" element={<Layout><FAQ /></Layout>} />
        <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/corporate" element={<Layout><Corporate /></Layout>} />
        <Route path="/diseases" element={<Layout><DiseasesIndex /></Layout>} />
        <Route path="/diseases/:letter" element={<Layout><Diseases /></Layout>} />
        <Route path="/diseases/detail/:id" element={<Layout><DiseaseDetail /></Layout>} />
        <Route path="/tests-procedures" element={<Layout><TestsProceduresIndex /></Layout>} />
        <Route path="/tests-procedures/:letter" element={<Layout><TestsProcedures /></Layout>} />
        <Route path="/tests-procedures/detail/:id" element={<Layout><TestProcedureDetail /></Layout>} />
        <Route path="/patient-centered-care" element={<Layout><PatientCenteredCare /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/services/:category" element={<Layout><Services /></Layout>} />
        <Route path="/services/:category/:letter" element={<Layout><Services /></Layout>} />
        <Route path="/services/detail/:id" element={<Layout><ServiceDetail /></Layout>} />
        <Route path="/senior-management/:id" element={<Layout><SeniorManagementDetail /></Layout>} />
        <Route path="/donors-partners/:id" element={<Layout><DonorPartnerDetail /></Layout>} />
        <Route path="/patient-visitor-guide" element={<Layout><PatientVisitorGuide /></Layout>} />
        <Route path="/insurance-self-pay" element={<Layout><InsuranceSelfPay /></Layout>} />
        <Route path="/bills-payments" element={<Layout><BillsPayments /></Layout>} />
        <Route path="/before-arriving" element={<Layout><BeforeArriving /></Layout>} />
        <Route path="/departments-centers" element={<Layout><DepartmentsCenters /></Layout>} />
        <Route path="/departments-centers/:letter" element={<Layout><DepartmentsCenters /></Layout>} />
        <Route path="/departments/:id" element={<Layout><DepartmentDetail /></Layout>} />
        <Route path="/symptoms/related" element={<Layout><SymptomRelated /></Layout>} />
        <Route path="/symptoms" element={<Layout><SymptomsIndex /></Layout>} />
        <Route path="/symptoms/:letter" element={<Layout><Symptoms /></Layout>} />
        <Route path="/support-tgh" element={<Layout><SupportTGH /></Layout>} />
        <Route path="/blog" element={<Layout><Blog /></Layout>} />
        <Route path="/blog/:id" element={<Layout><BlogDetail /></Layout>} />
        <Route path="/events" element={<Layout><Events /></Layout>} />
        <Route path="/events/:id" element={<Layout><EventDetail /></Layout>} />
        <Route path="/projects" element={<Layout><Projects /></Layout>} />
        <Route path="/projects/:id" element={<Layout><ProjectDetail /></Layout>} />
        
        {/* Admin routes without Layout */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/news" element={<AdminNews />} />
        <Route path="/admin/diseases" element={<AdminDiseases />} />
        <Route path="/admin/services" element={<AdminServices />} />
        <Route path="/admin/senior-management" element={<AdminSeniorManagement />} />
        <Route path="/admin/donors-partners" element={<AdminDonorsPartners />} />
        <Route path="/admin/departments" element={<AdminDepartments />} />
        <Route path="/admin/symptom-browse" element={<AdminSymptomBrowse />} />
        <Route path="/admin/tests-procedures" element={<AdminTestsProcedures />} />
        <Route path="/admin/blogs" element={<AdminBlogs />} />
        <Route path="/admin/events" element={<AdminEvents />} />
        <Route path="/admin/gallery" element={<AdminGallery />} />
        <Route path="/admin/projects" element={<AdminProjects />} />
        <Route path="/admin/announcements" element={<AdminAnnouncements />} />
        <Route path="/admin/activity-logs" element={<AdminActivityLogs />} />
        <Route path="/admin/security" element={<AdminSecurityDashboard />} />
        <Route path="/admin/backups" element={<AdminBackups />} />
        <Route path="/admin/change-password" element={<AdminChangePassword />} />
      </Routes>
    </Router>
  );
}

export default App;
